import { Observable, Subject } from 'rxjs';


export class GDPRAgreement {
	public GDPRAgreementId: number;
	public GDPRAgreementContent: string;
	public GDPRAgreementDate: string;

	public constructor(id, content, date) {
		this.GDPRAgreementId = id;
		this.GDPRAgreementContent = content;
		this.GDPRAgreementDate = date;
	}
}
